<template>
    <div class="ai_character_box">
        <div v-for="(item, index) in bannerData" :key="index" class="ai_character_item">
        
            <img :src="item.image" alt="Computer" />
            <div class="ai_content">
            <div class="ai_title">{{ item.title }}</div>
            <div class="details_content">
               {{ item.desc }}
            </div></div>

        </div>
    </div>
</template>

<script>
import { bannerData } from "./data";

export default {
    data() {
        return {
            bannerData,
        };
    },
};
</script>

<style lang="scss">
.ai_character_box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
   

    .ai_character_item {
        padding: 50px 0;
        flex: 0 0 32%;
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 20px;
        text-align: center;
        background: rgba(255, 255, 255, 0.7); 
        box-shadow: 0px 1px 7px 1px rgba(90, 114, 234, 0.03);
        border-radius: 12px;
        img {
            margin-top: -102px;
            width: 90px;
        }
        .ai_content{
            padding:0 60px;
        }
        .ai_title {
            font-size: 26px;
            font-weight: bold;
            line-height: 36px;
            margin-bottom: 12px;
        }

       .details_content {
            font-size: 14px;
            color: #333;
            line-height: 20px;
        }

    }
}

@media (max-width: 576px) {
    .ai_character_box {
        gap: 20px;

        .ai_character_item {
            flex: initial;
            width: 100%;
        }
    }
}
</style>
